import { Outlet, createFileRoute } from '@tanstack/react-router'
import { PageWithRedirectSearchSchema } from '@/schemas/page'

export const Route = createFileRoute(
  '/make-booking/$id/bus-details/$transportationId/trip-type',
)({
  validateSearch: PageWithRedirectSearchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
